<template>
  <div>
    <b-modal v-model="showModalSelectAddress"
             title="Título do Modal"
             no-close-on-esc
             no-close-on-backdrop
             hide-header
             hide-footer
             centered>

      <div class="d-flex flex-column align-items-center justify-center-center my-2">
        <h2>Selecione um endereco da empresa</h2>
        <b-col v-if="exibirEnderecoSelect" lg="12" md="12" sm="12" class="mt-2">
          <b-form-group
              label="Endereço Empresa*"
              label-for="endereco-input">
            <validation-provider
                #default="{ errors }"
                name="endereco"
                rules="required"
            >
              <v-select
                  id="endereco-input"
                  v-model="address"
                  :options="addressSelectFormated"
                  label="descricao"
                  placeholder="Endereço empresa"
                  :clearable="true"
              >
                <span slot="no-options">Nenhuma opção selecionável.</span>
              </v-select>
              <small v-if="errors[0]" class="text-danger">
                Este campo é de preenchimento obrigatório.
              </small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <div class="d-flex mt-2">
          <b-button variant="primary-button" class="mr-2" @click="downloadSpreadsheet">
            Selecionar
          </b-button>

          <b-button :variant="'outline-custom-blue'" @click="closeModalSelectAddress">
            Cancelar
          </b-button>

        </div>
      </div>

    </b-modal>

    <section class="import-file-section">
      <div class="instructions">
        <img
          alt="download-icon"
          src="@/assets/custom-icons/download-icon.svg"
        >
        <p>
          <button
            class="btn-unset"
            @click="downloadSpreadsheet"
          >
            Faça o download
          </button>
          da planilha de vacinados, verifique os dados e preencha os campos faltantes.
          Após verificação, salve no formato .xlsx e importe a planilha.
        </p>
      </div>

      <div class="file-input">
        <p>Importar planilha:</p>
        <b-form-file
          v-model="sheetFile"
          size="md"
          class="customFileButton"
          placeholder="Nenhum arquivo selecionado"
          drop-placeholder="Insira o arquivo aqui..."
          browse-text="Escolher arquivo"
          variant="primary"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          @change="handleFileChange"
        />
        <small
          v-if="!canDoUpload"
          style="color: #ff1010"
        >Este campo é de preenchimento obrigatório</small>
      </div>

      <CustomModalComponent
        :show-modal="showErrorModal"
        kind="error"
        title="Erro na Importação"
        content="O modelo da planilha que está sendo utilizado na importação não é mais válido. Verifique e tente novamente"
        confirm-button-label="Ok"
        @confirmed="confirmActionErrorModal"
      />

      <CustomModalComponent
        :show-modal="this.$data.showSuccessModal"
        kind="success"
        title="Importação em andamento"
        content="Notificaremos assim que acabar."
        confirm-button-label="Ok"
        @confirmed="confirmActionSuccessModal"
      />
    </section>


    <section class="import-file-button">
      <b-button
        id="import-colaborador"
        class="mr-2 mb-2-sm"
        variant="custom-blue"
        :disabled="disabledButton"
        @click="importFileHandler"
      >
        <feather-icon
          icon="DownloadIcon"
          class="mr-50"
        />
        <span
          v-if="disabledButton"
          class="align-middle"
        >Processando...</span>
        <span
          v-if="!disabledButton"
          class="align-middle"
        >Importar</span>
      </b-button>
    </section>
  </div>
</template>

<script>
import {BButton, BCol, BFormFile, BFormGroup, BModal, BTooltip} from 'bootstrap-vue'
import moment from 'moment/moment'
import CustomModalComponent from '@/views/custom-pages/Vacinacao/Pages/Importacao/Modal/CustomModalComponent.vue'
import { applyCpfMask } from '@/helpers/string'
import vSelect from "vue-select";
import {ValidationProvider} from "vee-validate";

export default {
  components: {
    BTooltip,
    BModal,
    ValidationProvider, BCol, BFormGroup, vSelect,
    CustomModalComponent,
    BButton,
    BFormFile,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    enderecoSelect: {
      type: Array,
      default: () => []
    },
    exibirEnderecoSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      company: null,
      sheetFile: null,
      showSuccessModal: false,
      showErrorModal: false,
      canDoUpload: true,

      disabledButton: false,
      addressSelectFormated: [],
      address: null,
      showModalSelectAddress: false
    }
  },

  computed: {
    getSearch() {
      return this.params
    },

    grupo() {
      return this.getSearch?.grupo
    },

    idCampanha() {
      return this.getSearch.campanha.id_campanha
    },

    empresa() {
      return this.getSearch.empresa
    },

    unidade() {
      return this.getSearch.unidade
    },

    descricaoCampanha() {
      return this.getSearch.campanha.descricao_campanha
    },

    tipoCampanha() {
      return this.getSearch.campanha.tipo
    },

    idEmpresaEndereco() {
      return this.getSearch?.endereco?.id_empresa_endereco || null
    },

    empresaEndereco() {
      if (!this.getSearch?.endereco) {
        return null;
      }

      const endereco = this.getSearch.endereco;
      return this.formatAddress(endereco);
    },
  },

  watch: {
    enderecoSelect(newValue) {
      if (newValue) {
        this.addressSelectFormated = newValue.map(address => {
          return {
            idEmpresaEndereco: address.id_empresa_endereco,
            descricao: this.formatAddress(address)
          }
        });
      }
    }
  },

  methods: {
    closeModalSelectAddress() {
      this.showModalSelectAddress = false;
      this.address = null;
    },
    async setFieldsVaccine()
    {
      let doseVaccine = null;

      const companyAdhesionData = await this.$http.get(this.$api.empresasComAdesaoParaVacinacao(), {
        params: {
          id_empresa: this.empresa.id_empresa,
          id_campanha: this.grupo?.idGroup ? this.getSearch.campanha.idCampaign : this.idCampanha
        }
      });
      
      const vaccinesAdhesion = companyAdhesionData.data[0]?.ids_vacinas_aderidas;

      if(vaccinesAdhesion.length == 1) {
        const doses = this.getSearch.campanha.vacina.find(vacina => {
          return vacina.id_vacina == vaccinesAdhesion[0]
        }).doses

        doseVaccine = doses.length == 1 ? doses[0].dose.descricao : null;
      }else{
        const doses = this.getSearch.campanha.vacina.filter(vacina => vaccinesAdhesion.includes(vacina.id_vacina)).map(vacina => vacina.doses.map(dose => dose.dose.descricao)).flat();
        const uniqueDoses = [...new Set(doses)];

        doseVaccine = uniqueDoses.length == 1 ? doses[0] : null;
      }

      return doseVaccine
    },
    async downloadSpreadsheet() {
      if (this.grupo && !this.address) {
        this.showModalSelectAddress = true;
        return;
      }

      const doseVaccine = await this.setFieldsVaccine();

      let employees = await this.$http.get(this.$api.colaboradorVacinacao(), {
        params: {
          paginacao: false,
          ordem: 'asc',
          id_empresa: this.empresa.id_empresa,
          id_campanha: this.grupo?.idGroup ? this.getSearch.campanha.idCampaign : this.idCampanha,
          id_categoria: '',
          cpf: '',
          ano: moment().format('YYYY'),
          ativo: true,
          id_grupo: this.grupo?.idGroup
        },
      })

      employees = employees.data.data.filter(el => el.descricao_dose !== "Única" || !el.vacinado)
      let content = [];

      for (const item of employees) {
        content.push({
          VACINADO: 'Não',
          'DATA DE APLICAÇÃO': '',
          'CPF VACINADOR': '',
          LOTE: '',
          NOME: item.nome,
          CPF: applyCpfMask(item.cpf),
          CATEGORIA: item.categoria,
          CNPJ: this.empresa.documento_formatado,
          "ID EMPRESA ENDEREÇO": this.grupo ? this.address.idEmpresaEndereco : this.idEmpresaEndereco,
          "ENDEREÇO": this.grupo ? this.address.descricao : this.empresaEndereco,
          "CONDIÇÃO MATERNAL": 'Nenhuma',
          "DOSE APLICADA": doseVaccine,
          "LOCAL DE APLICAÇÃO": '',
          "TIPO DE APLICAÇÃO": '',
          "PRÓXIMA DOSE PREVISTA": item.data_proxima_dose ? moment(item.data_proxima_dose).format('DD/MM/YYYY') : '',
        })
      }

      this.$helpers.downloadArchiveXlsx(content, 'importacao_vacinacao.xlsx');
      this.closeModalSelectAddress();
    },
    async importFileHandler() {
      this.disabledButton = true

      if (!this.sheetFile) {
        this.canDoUpload = false
        this.disabledButton = false
        return
      }

      const formData = new FormData()
      formData.append('arquivo', this.sheetFile)
      formData.append('id_empresa', this.empresa.id_empresa)
      formData.append('cnpj', this.empresa.documento)
      formData.append('id_unidade', !this.grupo ? this.unidade.id_unidade : this.unidade.idUnit)
      formData.append('id_campanha', !this.grupo ? this.idCampanha : this.getSearch.campanha.idCampaign)
      formData.append('tipo', this.tipoCampanha)
      formData.append('id_empresa_endereco', this.idEmpresaEndereco)
      
      await this.$http.post(this.$api.importarVacinados(), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(() => {
        this.showSuccessModal = true
        this.refreshTable()
        this.sheetFile = null
        this.canDoUpload = true
      }).catch(() => {
        this.showErrorModal = true
      })

      this.disabledButton = false
    },
    handleFileChange(event) {
      this.sheetFile = event.target.files.length > 0 ? event.target.files[0] : null
      this.canDoUpload = !!this.sheetFile
    },
    refreshTable() {
      this.$emit('refresh')
    },
    confirmActionSuccessModal() {
      this.showSuccessModal = false
    },
    confirmActionErrorModal() {
      this.showErrorModal = false
    },
    formatAddress(address) {
      let fullAddess = "";

      const cidade = address.nome_cidade ?? address.cidadeNome;
      const uf = address.uf ?? address.estadoUF;

      fullAddess += address.logradouro + ', ';
      fullAddess += (address.numero || 'S/N') + ' - ';
      fullAddess += address.bairro + ', ';
      fullAddess += cidade + ' - ';
      fullAddess += uf + ', ';
      fullAddess += (address.cep || '');

      return fullAddess;
    }
  },
}
</script>

<style scoped lang="scss">
.import-file-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 2em;
  border: 1px solid #D8D6DE;
  border-radius: 6px;

  a {
    text-decoration: underline;
  }

  .instructions,
  .file-input {
    width: 50%;
  }

  .file-input {
    padding: 0 2.5em;
    cursor: pointer;

    p {
      margin-bottom: 10px;
    }

  }

  .instructions {
    background: #F3F2F7;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 2.5em;
    gap: 2em;

    p {
      color: #6E6B7B;
      font-size: 1.1rem;
      margin: auto 0;
    }
  }
}

.import-file-button {
  width: 100%;
  margin: 2em 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.btn-unset {
  border: none;
  background: transparent;
  padding: 0;
  color: #2772C0;
  text-decoration: underline;
}

@media (max-width: 425px) {
  .import-file-section {
    flex-direction: column;
  }

  .instructions,
  .file-input {
    width: 100% !important;
  }
}

.customFileButton {
  ::after {
    color: #2772c0 !important;
    border: 1px solid #2772c0 !important;
    border-radius: 4px !important;
  }
}
</style>
